import { useEffect, useState } from 'react';

const URL = `${process.env.REACT_APP_BACKEND_URL}/api/v1/features`;

const FALLBACK = { disputes_enabled: false, broadcast_all_enquiries: true, split_payment_threshold: 20000, advance_percent_at_threshold: 50, quote_validity_days: 7 };

let cache = null;
let inflight = null;

export function loadFeatures() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = fetch(URL)
      .then((r) => r.json())
      .then((d) => { cache = { ...FALLBACK, ...d }; return cache; })
      .catch(() => FALLBACK)
      .finally(() => { inflight = null; });
  }
  return inflight;
}

/** Platform feature switches (admin-controlled). Starts from the safe default. */
export function useFeatures() {
  const [features, setFeatures] = useState(cache || FALLBACK);
  useEffect(() => { loadFeatures().then(setFeatures); }, []);
  return features;
}
